import axios from "axios";
import { APP_VERSION, apiUrl } from "../../../config/const";
import { flashError } from "../../../core/utils/flashMessage";
import {
  getHttpClient,
  errorDesconocido,
  safeHandle401,
} from "../../../core/utils/httpClient";

import indexOf from "lodash/indexOf";

var jwtDecode = require("jwt-decode");

export const CLIENT_MANAGER = ["ROLE_MANAGER_ADMIN", "ROLE_MANAGER_CLIENT"]; //ROLE_TYPE_MANAGER
export const VENDOR_MANAGER = ["ROLE_MANAGER_ADMIN", "ROLE_MANAGER_VENDOR"]; //ROLE_TYPE_MANAGER
export const FINANCE_MANAGER = ["ROLE_MANAGER_ADMIN", "ROLE_MANAGER_FINANCE"]; //ROLE_TYPE_MANAGER
export const PROJECT_MANAGER = ["ROLE_MANAGER_ADMIN", "ROLE_MANAGER_PROJECT"]; //ROLE_TYPE_MANAGER
export const ADMIN_MANAGER = ["ROLE_MANAGER_ADMIN"]; //ROLE_TYPE_MANAGER

export function error(error) {
  return { type: "CONFIG_SESSION_ERROR", error };
}

export function loading(loading) {
  return { type: "CONFIG_SESSION_LOADING", loading };
}

export function set(data) {
  return { type: "CONFIG_SESSION_SET", data };
}

export function setImage(data) {
  return { type: "CONFIG_SESSION_SET_IMAGE", data };
}

export function update(data) {
  return { type: "CONFIG_SESSION_UPDATE", data };
}

export function reset() {
  return { type: "CONFIG_SESSION_RESET" };
}

export function login({ username, password, subdomain }) {
  return async (dispatch, getState) => {
    dispatch(reset());
    dispatch(loading(true));

    var headers = {
      "Content-Type": "application/json",
    };

    try {
      const form = { username, password };
      const url = apiUrl(subdomain, "login_check");

      const response = await axios.post(url, form, { headers: headers });

      /**
       * Response debería tener los siguientes datos
       *
       * - response.data.token
       * - response.data.refresh_token
       */
      const decoded = jwtDecode(response.data.token);
      const data = {
        user: username,
        token: response.data.token,
        roles: decoded.roles,
        iat: decoded.iat,
        exp: decoded.exp,
        refresh_token: response.data.refresh_token,
        subdomain: subdomain,
      };

      localStorage.setItem("roles", decoded.roles);
      localStorage.setItem("subdomain", subdomain);
      localStorage.setItem("access-token", response.data.token);
      localStorage.setItem("refresh-token", response.data.refresh_token);

      dispatch(set(data));
      dispatch(loading(false));

      return data;
    } catch (e) {
      if (e.response) {
        if (e.response.status == 401) {
          flashError({ description: "Los datos de acceso son incorrectos!" });
          return e.response.data;
        }
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        if (e.response.status == 404) {
          dispatch(error(e.response.data));
          flashError({ description: "Se ha producido un error desconocido" });
        } else if (e.response.status != 400) {
          flashError({ description: "Se ha producido un error desconocido" });
        }

        return e.response.data;
      }

      dispatch(error("Error desconocido"));
      flashError({ description: "Se ha producido un error desconocido" });
      return "Error";
    }
  };
}

export function logout() {
  return (dispatch, getState) => {
    dispatch(reset());
  };
}

export const getUser = (state) => {
  if (state.config.session.data) {
    return state.config.session.data;
  }

  return [];
};

/*

export const is_granted = (role) => (dispatch, getState) => {
    const roles = getState().session.roles;
    return true;
    //return indexOf(roles, role) >= 0;
}

*/
export async function refresh(dispatch, state) {
  const refresh_token = state.config.session.data.refresh_token;
  const subdomain = state.config.session.data.subdomain;

  var headers = {
    "Content-Type": "application/json",
  };

  try {
    const url = apiUrl(subdomain, "token/refresh?version=" + APP_VERSION);
    const response = await axios.post(
      url,
      { refresh_token },
      { headers: headers }
    );

    var decoded = jwtDecode(response.data.token);
    const data = {
      token: response.data.token,
      roles: decoded.roles,
      iat: decoded.iat,
      exp: decoded.exp,
      refresh_token: response.data.refresh_token,
    };

    localStorage.setItem("roles", decoded.roles);
    localStorage.setItem("subdomain", subdomain);
    localStorage.setItem("access-token", response.data.token);
    localStorage.setItem("refresh-token", response.data.refresh_token);

    dispatch(update(data));

    return response.data;
  } catch (e) {
    return false;
  }
}

export function getLoginImage() {
  return async (dispatch, getState) => {
    dispatch(error(""));

    var headers = {
      "Content-Type": "application/json",
    };

    try {
      const cliente = await getHttpClient(dispatch, getState());
      const response = await cliente.get(
        "react/v1/configurations/loginImage",
        {},
        { headers: headers }
      );

      dispatch(setImage(response.data));

      return true;
    } catch (e) {
      /*.catch(handle401(dispatch, getState))*/
      const test401 = safeHandle401(dispatch, getState);
      test401(e);
      dispatch(setImage(null));
      if (e.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        if (e.response.status == 404) {
          dispatch(error(e.response.data));
          alert("Error 404 ");
        } else if (e.response.status != 400) {
          alert("Error desconocido");
        }

        return e.response.data;
      }

      dispatch(error("Error desconocido"));
      errorDesconocido();
      return "Error";
    }
  };
}

export function setLoginImage(form) {
  return async (dispatch, getState) => {
    dispatch(error(""));

    var headers = {
      "Content-Type": "application/json",
    };

    try {
      const cliente = await getHttpClient(dispatch, getState());
      const response = await cliente.post(
        "react/v1/configurations/loginImage",
        form,
        { headers: headers }
      );

      dispatch(setImage(response.data));

      return true;
    } catch (e) {
      /*.catch(handle401(dispatch, getState))*/
      const test401 = safeHandle401(dispatch, getState);
      test401(e);
      dispatch(setImage(null));
      if (e.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        if (e.response.status == 404) {
          dispatch(error(e.response.data));
          alert("Error 404 ");
        } else if (e.response.status != 400) {
          alert("Error desconocido");
        }

        return e.response.data;
      }

      dispatch(error("Error desconocido"));
      errorDesconocido();
      return "Error";
    }
  };
}

export function deleteLoginImage() {
  return async (dispatch, getState) => {
    dispatch(error(""));

    var headers = {
      "Content-Type": "application/json",
    };

    try {
      const cliente = await getHttpClient(dispatch, getState());
      await cliente.delete(
        "react/v1/configurations/loginImage",
        {},
        { headers: headers }
      );

      dispatch(setImage(null));

      return true;
    } catch (e) {
      /*.catch(handle401(dispatch, getState))*/
      const test401 = safeHandle401(dispatch, getState);
      test401(e);
      dispatch(setImage(null));
      if (e.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        if (e.response.status == 404) {
          dispatch(error(e.response.data));
          alert("Error 404 ");
        } else if (e.response.status != 400) {
          alert("Error desconocido");
        }

        return e.response.data;
      }

      dispatch(error("Error desconocido"));
      errorDesconocido();
      return "Error";
    }
  };
}

export const getUserRoles = (state) => {
  return state.config.session.data.roles || [];
};

export const isUserOwner = (state) => {
  const user = getUserSession(state);

  return user === "admin";
};

export const getUserSession = (state) => {
  return state.config.session.data.user || false;
};

/**
 * Función que cheque si un usuario tiene el un role dado
 */
export const isGranted = (role, roles) => {
  return indexOf(roles, role) >= 0;
};

/**
 * Función que cheque si un usuario tiene al menos uno de los roles pasados como parametros
 */
export const isGrantedSome = (permisos, roles) => {
  return permisos.some((role) => indexOf(roles, role) >= 0);
};

export const isAdminManager = (roles) => isGrantedSome(ADMIN_MANAGER, roles);
export const isProjectManager = (roles) =>
  isGrantedSome(PROJECT_MANAGER, roles);
export const isFinanceManager = (roles) =>
  isGrantedSome(FINANCE_MANAGER, roles);
export const isVendorManager = (roles) => isGrantedSome(VENDOR_MANAGER, roles);
export const isClientManager = (roles) => isGrantedSome(CLIENT_MANAGER, roles);

export const isAdmin = (state) => {
  const roles = getUserRoles(state);

  return isAdminManager(roles);
};
